import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8194">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8195">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8196">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8197">
            <ArrowLeft className="w-4 h-4" data-id="element-8198" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8199">NOIZA</div>
          <div className="w-20" data-id="element-8200" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8201">
        <div className="mb-12" data-id="element-8202">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8203">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8204" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8205">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8206">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8207">
          <section data-id="element-8208">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8209">
              <span className="text-[#006847]" data-id="element-8210">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8211">
              <p data-id="element-8212">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8213">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8214">
                <li data-id="element-8215">Haber leído íntegramente este documento</li>
                <li data-id="element-8216">Comprender su contenido en su totalidad</li>
                <li data-id="element-8217">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8218">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8219">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8220">
              <span className="text-[#006847]" data-id="element-8221">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8222">
              <p data-id="element-8223">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8224">
                <li data-id="element-8225">Software como servicio (SaaS)</li>
                <li data-id="element-8226">Marketplace digital gastronómico</li>
                <li data-id="element-8227">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8228">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8229">
                <li data-id="element-8230">Mostrar su menú digital</li>
                <li data-id="element-8231">Recibir pedidos de clientes</li>
                <li data-id="element-8232">Gestionar su operación interna</li>
                <li data-id="element-8233">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8234">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8235">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8236">
              <span className="text-[#006847]" data-id="element-8237">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8238">
              <p data-id="element-8239">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8240">
                <li data-id="element-8241">No es proveedor de alimentos</li>
                <li data-id="element-8242">No participa en la preparación de productos</li>
                <li data-id="element-8243">No manipula alimentos en ningún momento</li>
                <li data-id="element-8244">No realiza entregas ni logística</li>
                <li data-id="element-8245">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8246">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8247">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8248">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8249">
              <span className="text-[#006847]" data-id="element-8250">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8251">
              <p data-id="element-8252">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8253">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8254">
                <li data-id="element-8255">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8256">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8257">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8258">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8259">
                <li data-id="element-8260">Precios</li>
                <li data-id="element-8261">Menú</li>
                <li data-id="element-8262">Horarios</li>
                <li data-id="element-8263">Métodos de pago</li>
                <li data-id="element-8264">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8265">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8266">
              <span className="text-[#006847]" data-id="element-8267">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8268">
              <div data-id="element-8269">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8270">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8271">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8272">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8273">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8274">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8275">
                  <li data-id="element-8276">Calidad de los alimentos</li>
                  <li data-id="element-8277">Estado, frescura o preparación</li>
                  <li data-id="element-8278">Ingredientes utilizados</li>
                  <li data-id="element-8279">Contaminación cruzada</li>
                  <li data-id="element-8280">Problemas de higiene o salubridad</li>
                  <li data-id="element-8281">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8282">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8283">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8284">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8285">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8286">
                  <li data-id="element-8287">Retrasos en la entrega</li>
                  <li data-id="element-8288">Pérdida de pedidos</li>
                  <li data-id="element-8289">Entregas incompletas</li>
                  <li data-id="element-8290">Errores en dirección</li>
                  <li data-id="element-8291">Conducta de repartidores</li>
                  <li data-id="element-8292">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8293">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8294">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8295">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8296">
                  <li data-id="element-8297">Recepción de pagos</li>
                  <li data-id="element-8298">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8299">Manejo de efectivo</li>
                  <li data-id="element-8300">Confirmación de pagos</li>
                  <li data-id="element-8301">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8302">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8303">
                  <li data-id="element-8304">Pagos no recibidos</li>
                  <li data-id="element-8305">Comprobantes falsos</li>
                  <li data-id="element-8306">Errores en montos</li>
                  <li data-id="element-8307">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8308">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8309">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8310">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8311">
                  <li data-id="element-8312">Reclamos de clientes</li>
                  <li data-id="element-8313">Reembolsos</li>
                  <li data-id="element-8314">Cancelaciones</li>
                  <li data-id="element-8315">Disputas</li>
                  <li data-id="element-8316">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8317">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8318">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8319">
              <span className="text-[#006847]" data-id="element-8320">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8321">
              <p data-id="element-8322">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8323">
                <li data-id="element-8324">Responsable</li>
                <li data-id="element-8325">Legal</li>
                <li data-id="element-8326">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8327">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8328">
                <li data-id="element-8329">Publicar información falsa</li>
                <li data-id="element-8330">Manipular precios de forma engañosa</li>
                <li data-id="element-8331">Simular disponibilidad inexistente</li>
                <li data-id="element-8332">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8333">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8334">
              <span className="text-[#006847]" data-id="element-8335">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8336">
              <p data-id="element-8337">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8338">
                <li data-id="element-8339">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8340">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8341">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8342">
                <li data-id="element-8343">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8344">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8345">
                    <li data-id="element-8346">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8347">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8348">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8349">
              <span className="text-[#006847]" data-id="element-8350">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8351">
              <p data-id="element-8352">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8353">
                <li data-id="element-8354">Menú digital</li>
                <li data-id="element-8355">Gestión de pedidos</li>
                <li data-id="element-8356">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8357">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8358">
                  <p className="font-medium text-white mb-2" data-id="element-8359">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8360">
                    <li data-id="element-8361">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8362">
                  <p className="font-medium text-white mb-2" data-id="element-8363">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8364">
                    <li data-id="element-8365">Propiedad del software</li>
                    <li data-id="element-8366">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8367">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8368">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8369">
              <span className="text-[#006847]" data-id="element-8370">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8371">
              <p data-id="element-8372">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8373">
                <li data-id="element-8374">Disponibilidad continua</li>
                <li data-id="element-8375">Funcionamiento sin interrupciones</li>
                <li data-id="element-8376">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8377">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8378">
                <li data-id="element-8379">Fallas técnicas</li>
                <li data-id="element-8380">Actualizaciones</li>
                <li data-id="element-8381">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8382">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8383">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8384">
              <span className="text-[#006847]" data-id="element-8385">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8386">
              <p data-id="element-8387">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8388">
                <li data-id="element-8389">No está garantizada permanentemente</li>
                <li data-id="element-8390">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8391">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8392">
                <li data-id="element-8393">Destacar o no restaurantes</li>
                <li data-id="element-8394">Modificar posiciones</li>
                <li data-id="element-8395">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8396">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8397">
              <span className="text-[#006847]" data-id="element-8398">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8399">
              <p data-id="element-8400">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8401">
                <li data-id="element-8402">Cumplir con los pagos acordados</li>
                <li data-id="element-8403">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8404">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8405">
                <li data-id="element-8406">Suspender el servicio</li>
                <li data-id="element-8407">Limitar funcionalidades</li>
                <li data-id="element-8408">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8409">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8410">
              <span className="text-[#006847]" data-id="element-8411">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8412">
              <p data-id="element-8413">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8414">
                <li data-id="element-8415">Incumplimiento de términos</li>
                <li data-id="element-8416">Uso indebido</li>
                <li data-id="element-8417">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8418">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8419">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8420">
              <span className="text-[#006847]" data-id="element-8421">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8422">
              <p data-id="element-8423">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8424">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8425">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8426">
              <span className="text-[#006847]" data-id="element-8427">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8428">
              <p data-id="element-8429">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8430">
                <li data-id="element-8431">Pérdidas económicas</li>
                <li data-id="element-8432">Daños indirectos</li>
                <li data-id="element-8433">Lucro cesante</li>
                <li data-id="element-8434">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8435">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8436">
              <span className="text-[#006847]" data-id="element-8437">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8438">
              <p data-id="element-8439">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8440">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8441">
              <span className="text-[#006847]" data-id="element-8442">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8443">
              <p className="font-medium" data-id="element-8444">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8445">
                <li data-id="element-8446">Ha leído este documento completo</li>
                <li data-id="element-8447">Comprende su alcance</li>
                <li data-id="element-8448">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}